<template>
  <div id="left-menu" :class="{ opened: expanded }">
    <!-- Logo -->
    <div
      class="mheader"
      v-on:click="redirect('home', $event)"
      :style="{
        'background-color': user.event_color,
        backgroundImage: 'url(' + user.event_logo + ')',
      }"
    >
      <!-- <img id="logo" :src="user.event_logo" alt="logo"> -->
      <div class="name">
        <span>{{ user.event_name | eventName }}</span>
      </div>
    </div>

    <div class="mbody hide-scrollbar">
      <!-- PersonProfile -->
      <div
        class="item"
        @click="redirect('home', $event)"
        :class="{ active: activePage == 'campus_home' }"
      >
        <p class="name">{{ player.name + " " + player.surname }}</p>
      </div>

      <!-- Payments  -->
      <div
        class="item"
        @click="redirect('payments', $event)"
        :class="{ active: activePage == 'campus_payments' }"
      >
        <p class="name">{{ $t("titles.payments_and_budget") }}</p>
      </div>

      <!-- Documents -->
      <div
        class="item"
        @click="redirect('documents', $event)"
        :class="{ active: activePage == 'campus_documents' }"
      >
        <p class="name">{{ $t("titles.documents") }}</p>
      </div>

      <!-- GIFT PGA -->
      <div
        class="item"
        v-if="event.type_id == 5"
        @click="redirect('giftpga', $event)"
        :class="{ active: activePage == 'campus_giftpga' }"
      >
        <p class="name">{{ $t("titles.gift_pga") }}</p>
      </div>

      <!-- PGA VIRTUAL -->
      <div
        class="item"
        @click="redirect('pga_virtual', $event)"
        v-if="is_virtual && activities_virtual"
      >
        <p class="name">{{ $t("titles.activities_day") }}</p>
      </div>

      <div
        v-if="show_transfer"
        class="item"
        @click="redirect('travels', $event)"
        :class="{ active: activePage == 'campus_travels' }"
      >
        <p class="name">{{ $t("titles.transfers") }}</p>
      </div>

      <div
        v-if="show_rooms"
        class="item"
        @click="redirect('rooms', $event)"
        :class="{ active: activePage == 'campus_rooms' }"
      >
        <p class="name">{{ $t("titles.campus_rooms") }}</p>
      </div>

      <div
        v-if="show_training"
        class="item"
        @click="redirect('training', $event)"
        :class="{ active: activePage == 'campus_training' }"
      >
        <p class="name">{{ $t("titles.campus_training") }}</p>
      </div>

      <!-- Photos -->
      <div
        class="item"
        @click="redirect('photos', $event)"
        :class="{ active: activePage == 'campus_photos' }"
        v-if="event.type_id != 5 || true"
      >
        <p class="name">{{ $t("titles.photos") }}</p>
      </div>

      <!-- Footer -->
      <div class="item" id="footer">
        <div @click="logout()" id="logout" class="name">{{ $t("logout") }}</div>
        <Language></Language>
        <div v-if="change_club" @click="changeClub" class="change_club">
          {{ !event.is_campus ? $t("change_club") : $t("change_participant") }}
        </div>
      </div>

      <a href="http://micsports.es/" target="_blank">
        <div class="item" id="legend">
            <span class="description">{{ $t("organitzation") }}</span>
            <span class="version">{{ version }}</span> 
        </div>
      </a>
    </div>
  </div>
</template>
<script>
import { Api } from "@/core/api.js";

import i18n from "@/i18n";
import Language from "@/components/ui/Language.vue";
const api = new Api();

export default {
  name: "LeftMenuCampus",

  components: {
    i18n,
    Language,
  },

  props: {
    expanded: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      activePage: "",
      is_virtual: false,
      activities: {
        "03-07-2022": {
          ca: "https://paugasolacademy.com/ca/jhklahsieh87ejsjaoiuhj88hgjhg/",
          es: "https://paugasolacademy.com/khgqqugj12kjgjkgk2kj656j65bmb4-53jhjhkks/",
          en: "https://paugasolacademy.com/en/hkjkpoep298-jkkghkhkjvmas98/",
        },
        "04-07-2022": {
          ca: "https://paugasolacademy.com/ca/jkjkldsa786jkhkhllagkhgajn/",
          es: "https://paugasolacademy.com/hjksjlkajlkhs678-jkhajkhakljhakjkl/",
          en: "https://paugasolacademy.com/en/kjhhaasllashale-66hgssasakhahkanin-879/",
        },
        "05-07-2022": {
          ca: "https://paugasolacademy.com/ca/sdghgkgkjkjgkj8712khggjg12hkakjbmakgkjbk/",
          es: "https://paugasolacademy.com/hjklkjooihjio0908-jhgkgkfkfferstf/",
          en: "https://paugasolacademy.com/en/enhlkhlkal6786-kbemjkbjkbejk1/",
        },
        "06-07-2022": {
          ca: "https://paugasolacademy.com/ca/uiyhjhlhli4547nmbajj-hjhhjkhkjkjmb/",
          es: "https://paugasolacademy.com/hlmjjajkhkj967hkgkghjgkj6556kjasdaad/",
          en: "https://paugasolacademy.com/en/7-kjhjklhpyono-knhjkkjnjl7878-jhgj-t/",
        },
        "07-07-2022": {
          ca: "https://paugasolacademy.com/ca/mnblkhlnhln29678956875bjhbgjgljkjkjkyu-gjkmmnitl757otlgjbg5i/",
          es: "https://paugasolacademy.com/hulh2kjhk8970oihlkjjktkjbj867l7uijkglljkbj/",
          en: "https://paugasolacademy.com/en/hkjkpoep298-jkkghkhkjvmas98/",
        },
        "08-07-2022": {
          ca: "https://paugasolacademy.com/ca/99uoiukjlkli7tluhjlbiugk-it76kuyvuy57/",
          es: "https://paugasolacademy.com/opjlkjo87896o-ithjkgi7687olhkkutuj/",
          en: "https://paugasolacademy.com/en/jlkj8-lhikhuhliuiuhuk785675-tkbg6/",
        },
      },
    };
  },

  methods: {
    onChangeRoute() {
      this.activePage = this.$route.name;
    },

    redirect(type, e) {
      e.preventDefault();
      e.stopPropagation();
      console.log("redirect->", type);
      switch (type) {
        case "home":
          this.$router
            .push({
              name: "campus_home",
              params: { campus_id: this.user.campus_id },
            })
            .catch((err) => {});
          break;
        case "payments":
          this.$router.push({ name: "campus_payments" }).catch((err) => {});
          break;
        case "documents":
          this.$router.push({ name: "campus_documents" }).catch((err) => {});
          break;
        case "photos":
          this.$router.push({ name: "campus_photos" }).catch((err) => {});
          break;
        case "travels":
          this.$router.push({ name: "campus_travels" }).catch((err) => {});
          break;
        case "rooms":
          this.$router.push({ name: "campus_rooms" }).catch((err) => {});
          break;
        case "training":
          this.$router.push({ name: "campus_training" }).catch((err) => {});
          break;
        case "pga_virtual":
          this.redirectPGAVirtual();
          break;
        case "giftpga":
          this.$router.push({ name: "campus_giftpga" }).catch((err) => {});
          break;
      }
    },

    redirectPGAVirtual() {
      window.open(this.activities_virtual, "_blank");
    },

    logout() {
      this.$overlay.hide();
      this.$emit("closeMenu");
      // clear local storage
      localStorage.removeItem("team_id");
      var self = this;
      api.get("logout").then(function (data) {
        var event = self.$store.getters.getCurrentEvent();
        self.$store.commit("user/setAuthenticate", false);
        self.$store.commit("setOverlayVisible", false);
        self.$store.commit("setUserMenuVisible", false);
        var campus = self.$store.getters["getCampus"];
        // campus ? self.$router.replace( { name: 'campus_login' } ) : self.$router.replace( { name: 'login' } );
        self.$router.replace({
          name: "event_login",
          params: {
            event: self.$root.formatEventUrl(event.name, event.edition),
          },
        });
      });
    },

    changeClub() {
      var self = this;
      var event = self.$store.getters.getCurrentEvent();

      api
        .login({
          username: this.user.username,
          password: this.user.password,
          event: event.id,
          route: "/login",
        })
        .then(function (response) {
          if (response.status) {
            self.error_message = false;
            self.$overlay.hide();

            if (
              typeof response.data.sel_club !== "undefined" &&
              response.data.sel_club
            ) {
              self.$store.commit("user/setAuthenticateSelClub", response.data);
              self.$router.push({
                name: "sel_club",
                params: {
                  event: self.$root.formatEventUrl(event.name, event.edition),
                },
              });
            } else {
              self.$store.commit("user/setAuthenticate", response.data);
              localStorage.setItem("token", response.data.token);

              self.$store.dispatch("loadTablesRelationship").then(function () {
                if (self.campus) {
                  self.$store.commit("setCampus", true);
                }
                self.$router.push({
                  name: "home",
                  params: {
                    event: self.$root.formatEventUrl(event.name, event.edition),
                  },
                });
              });
            }
          } else {
            self.error_message = true;
          }
        });
    },
  },

  computed: {
    version() {
      //return package.json version
      return require("@/../package.json").version;
    },
    user() {
      return this.$store.getters["user/getUser"];
    },

    player() {
      var oPlayer = JSON.parse(
        JSON.stringify(this.$store.getters["person/getPerson"])
      );

      if (oPlayer.campus) {
        var self = this;
        self.is_virtual = this.event.type_id == 5;
      }

      return oPlayer;
    },

    event() {
      return this.$store.getters.getCurrentEvent();
    },

    show_transfer() {
      return (
        this.player.bus &&
        this.player.bus != "null" &&
        parseInt(this.player.bus) != 0 &&
        ((this.player.join_campus &&
          this.player.join_campus != "null" &&
          this.$store.getters.getJoinCampus[
            this.player.join_campus
          ].name.includes("airport")) ||
          (this.player.pickup && this.player.pickup == 3)) &&
        this.show_rooms
      );
    },

    show_rooms() {
      return (
        this.player.modality &&
        parseInt(this.player.modality) == 1 &&
        [4,16].includes(parseInt(this.event.type_id))
      );
    },

    show_training() {
      return (
        this.event.type_id == 4 ||
        this.event.type_id == 5 ||
        this.event.type_id == 12 ||
        this.event.type_id == 13 ||
        this.event.type_id == 16
      );
    },

    change_club() {
      var user = this.$store.getters["user/getUser"];

      return typeof user.sel_club !== "undefined" && user.sel_club;
    },

    event() {
      return this.$store.getters.getCurrentEvent();
    },

    activities_virtual() {
      var date = moment().format("DD-MM-YYYY");
      if (this.activities[date]) {
        return this.activities[date][this.user.language];
      }
      return false;
    },
  },

  filters: {
    eventName(name) {
      if (name.toUpperCase() == "MICCAMP") return "MIC CAMP ANDORRA";
      else if (name.toUpperCase() == "MICCAMP BCN") return "MIC CAMP BARCELONA";
      return name;
    },
  },

  watch: {
    $route: "onChangeRoute",
  },

  created() {
    this.onChangeRoute();
  },
};
</script>
<style lang="scss" scoped>
$text-color: #eee;
$bg-color: #222;
$bg-color-hover: #2a2a2a;
$bg-alter-color: #333;
$bg-alter-color-hover: #3a3a3a;

#left-menu {
  background-color: #fff;
  // border-right: 1px solid #ddd;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  -webkit-box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.15);
  height: 100%;
  width: 300px;
  overflow: hidden;
  padding: 0;
  display: inline-block;
  top: $header-height;
  left: 0;
  top: 0;
  position: fixed;
  z-index: 30;
  transition-duration: 0.1s;

  .mheader {
    height: 160px;
    text-align: center;
    transition-duration: 0.2s;
    cursor: pointer;
    background-color: #111;
    @include background($position: center, $size: 100px);
    position: relative;

    .name {
      position: absolute;
      bottom: 0;
      text-align: center;
      margin: 5px 0;
      width: 100%;

      span {
        color: #fff;
        font-weight: bold;
        font-size: 18px;
      }
    }
  }

  .mbody {
    height: calc(100% - 100px);
    overflow: auto;
    padding: 15px;

    #club,
    #uniform {
      .name {
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .category {
      .team {
        margin: 10px 0;
        font-size: 15px;
        padding: 10px;
      }

      .active {
        background-color: #fff4d7;
      }
    }

    .item {
      background: #fff;
      padding: 10px;
      border-left: 5px solid transparent;
      cursor: pointer;

      &#category {
        border-bottom: 1px solid #ddd;

        .name {
          padding: 10px 0;
          text-transform: uppercase;
          font-weight: bold;
          font-family: Roboto-Bold;
          font-family: AvantGarde-Bold;
          @include background(
            $image: img("down.svg"),
            $position: right 0px center,
            $size: 14px
          );

          &.active {
            color: #fc8926;
          }

          &:hover {
            text-decoration: underline;
          }
        }
      }

      &#footer {
        display: none;

        #logout {
          @include background(
            $image: img("logout.svg"),
            $size: 20px,
            $position: left 6px center
          );
          width: calc(100% - 50px);
          padding-left: 33px;
          float: left;
          font-size: 16px;
          cursor: pointer;
        }

        .change_club {
          @include background(
            $image: img("change.svg"),
            $size: 20px,
            $position: 6px 30px
          );
          padding-left: 33px;
          font-size: 16px;
          cursor: pointer;
          font-family: AvantGarde-Bold;
        }
      }

      .name {
        font-family: AvantGarde-Bold;
      }

      &.active {
        border-left: 6px solid #fc8926;
        background-color: #fff4d7;
        border-radius: 2px;
      }

      .submenu {
        padding-left: 25px;

        .subitem {
          padding: 5px;
          padding-left: 10px;
          border-left: 5px solid transparent;

          .number {
            float: right;
            font-family: AvantGarde-Bold;
          }

          &.active {
            border-left: 6px solid #fc8926;
            background-color: #fff4d7;
            border-radius: 2px;
          }

          &:hover {
            text-decoration: underline;
          }

          .name {
          }
        }
      }
    }

    .menu-item {
      @include background(
        $image: img("users.svg"),
        $position: left 6px center,
        $size: 22px
      );
      @include display-flex();
      @include align-items();
      color: $text-color;
      height: 50px;
      width: 100%;
      font-size: 18px;
      padding-left: 36px;
      cursor: pointer;

      &.teams {
        background-image: img("users.svg");
        border-bottom: 2px solid #424242;
      }
    }

    .info {
      @include display-flex();
      @include align-items();
      @include flex-wrap(wrap);
      min-height: 50px;
      height: auto;
      cursor: pointer;

      .club {
        @include background(
          $image: (
            img("club.svg"),
            img("right_light.svg"),
          ),
          $position: (
            left 8px center,
            right 12px center,
          ),
          $size: (
            26px,
            12px,
          )
        );
        width: 100%;
        padding: 12px 24px 6px 42px;

        p {
          @include text-ellipsis();
          margin: 0;
          color: $text-color;
          text-align: left;
          line-height: 0.8;
        }
        .club-name {
          font-size: 22px;
          margin: 20px 0;
        }
        .name {
          font-size: 18px;
          text-transform: uppercase;
        }
        .category {
          font-size: 15px;
          text-transform: uppercase;
        }
      }

      .team {
        @include display-flex();
        @include flex-wrap(wrap);
        @include align-items(center);
        // padding: 6px 6px 9px 6px;
        // padding: 0px 6px 0px 6px;
        padding: 0px;
        width: 100%;
        height: 40px;
        background-color: #333;
        // border-bottom: 1px solid #222;

        .name {
          @include text-ellipsis();
          text-transform: uppercase;
          color: $text-color;
          margin: 0;
          padding: 0;
          padding-left: 12px;
          text-align: left;
          font-size: 20px;
          font-weight: bold;
          width: 100%;
          // height: 100%;
          line-height: 40px;
          display: inline-block;

          &.expandable {
            @include background(
              $image: img("down_caret_eee.svg"),
              $position: left 9px center,
              $size: 7px
            );
            padding-left: 22px;
          }
        }

        .change-team {
          display: none;
        }
      }

      .team.opened {
        height: auto;

        .name.expandable {
          background-image: img("up_caret_light.svg");
        }

        .change-team {
          // border-top: 1px solid #171717;
          // background-color: rgba(255, 255, 255, 0.01);
          background-color: #444;
          display: block;
          width: 40px;
          width: 100%;
          padding-left: 12px;

          .item {
            @include text-ellipsis();
            line-height: 40px;
            color: $text-color;
            padding-left: 6px;
            font-size: 18px;
            transition-duration: 0.1s;

            &:hover {
              // background-color: rgba(255, 255, 255, 0.05);
              cursor: pointer;
              font-weight: bold;
            }
          }
        }
      }

      &:hover {
        background-color: $bg-color-hover;
      }
    }

    .resume {
      background-color: $bg-alter-color;
      padding: 0;

      .item {
        @include background(
          $image: img("right_light.svg"),
          $size: 12px,
          $position: right 6px center
        );
        @include border-radius(3px);
        @include display-inline-flex();
        @include align-items();
        height: 50px;
        width: calc(100% - 20px);
        background-color: #111;
        margin: 10px 10px 0 10px;
        padding: 2px 9px 2px 0px;
        cursor: pointer;
        transition-duration: 0.2s;

        .value,
        .label {
          color: $text-color;
        }
        .value {
          width: 75px;
          height: 100%;
          font-size: 24px;
          font-weight: bold;
          text-align: center;

          .count,
          .total {
            display: inline-block;
            color: $text-color;
            line-height: 45px;
          }
          .count {
            font-size: 30px;
            margin-right: 2px;
          }
          .total {
            font-size: 16px;
            font-weight: bold;
          }
        }
        .label {
          @include text-ellipsis();
          width: calc(100% - 75px);
          font-size: 17px;
        }

        &:hover {
          background-color: $bg-color;
        }
        &:last-of-type {
          margin-bottom: 10px;
        }

        &.alert {
          @include background(
            $image: (
              img("right_light.svg"),
              linear-gradient(115deg, $warning-color 0%, transparent 50%),
            ),
            $size: (
              12px,
              cover,
            ),
            $position: (
              right 6px center,
              center,
            )
          );
          // @include background ( $image: img('right_light.svg'), $color: $warning-color, $size: 12px, $position: right 6px center );

          .label {
          }
          .value {
            @include background(
              $image: img("empty_estimated.svg"),
              $size: 26px,
              $position: center
            );
          }
        }
      }
    }

    .categoryList {
      // max-height: calc(100% - 50px);
      // overflow: auto;
      background-color: #111;

      .category {
        // margin-top: 12px;
        padding: 6px;

        &:first-of-type {
          // margin-top: 0;
        }

        .title-cat {
          text-transform: uppercase;
          color: #aaa;
          text-align: left;
          font-size: 12px;
          margin: 0;

          span {
            text-transform: inherit;
            text-align: inherit;
            font-size: inherit;
            font-weight: bold;
            color: #ddd;
          }
        }

        .team {
          @include display-flex();
          @include align-items();
          height: 35px;
          border-bottom: 1px solid $bg-alter-color;
          cursor: pointer;
          text-align: left;

          &:last-of-type {
            border: none;
          }

          &:before {
            @include border-radius(8px);
            content: "";
            height: 8px;
            width: 8px;
            background-color: transparent;
            display: inline-block;
            margin-right: 4px;
          }

          .name {
            @include background($size: 20px, $position: right 6px center);
            @include display-flex();
            @include align-items();
            @include text-ellipsis();
            color: $text-color;
            font-size: 16px;
            width: 100%;
            height: 100%;
            padding-right: 30px;
            transition-duration: 0.2s;
          }

          &:hover .name {
            font-weight: bold;
          }
        }
      }
    }
  }

  .mfooter {
    position: absolute;
    bottom: 0;
    background-color: $bg-alter-color;
    width: 100%;
    height: 50px;

    > div {
      @include text-ellipsis();
      height: 100%;
      display: flex;
      align-items: center;
    }

    .logout {
      @include background(
        $image: img("logout.svg"),
        $size: 20px,
        $position: left 6px center
      );
      width: calc(100% - 50px);
      padding-left: 33px;
      float: left;
      font-size: 16px;
      cursor: pointer;
      color: #eee;
    }
  }

  #legend {
    height: 50px;
    width: 100%;
    border-top: 1px solid #eee;
    position: absolute;
    bottom: 0;
    left: 0;
    transition: background-color 0.5s ease;

    @include background(
      $image: img("logo_new_black.png"),
      $position: center,
      $size: 80px
    );

    &:hover {
      background-color: #e8e8e8;
    }

    span {
      display: block;
      margin: 0 auto;
      text-align: center;
      padding: 5px 170px 0 0;
    }
  }

  @include media(">=tablet", "<desktop") {
  }

  @include media(">phone", "<tablet") {
    width: 0;

    &.opened {
      width: calc(100% - 50px);
    }

    .mbody {
      .item {
        &#footer {
          display: block;
        }
      }
    }

    #legend {
      span {
        text-align: inherit;
        padding-left: 15px;
      }
    }
  }
}

@include media("<tablet") {
  #left-menu {
    z-index: 99999;
  }
}

.active {
  // background-color: $main-color !important;

  // border: 2px solid $main-color-t40;

  // &:hover {
  //   background-color: $secondary-color;
  // }
}
.active-dark {
  background-color: $main-color-s30 !important;

  // &:hover {
  //   background-color: $secondary-color;
  // }
}

@media print {
  #left-menu {
    width: 0;
  }
}
</style>
